<template>
<div class="chapter">
<div class="inner_page">
<p class="C308" style="margin-bottom:8px;"><a id="page_23">I</a></p><a id="page_23">
<p class="C308" style="margin-top:0px;"><strong>Freak Show: The Institution</strong></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_I__Freak.vue?3c3e2c6f